import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const ContactComponent = () => {
  return (
    <Container style={{ marginBottom: "100px" }}>
      <Row className="justify-content-center">
        <Col xs={12} md={4} className="mb-4">
          <Card className="h-100 border-0 shadow">
            <Card.Body
              className="text-center"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="rounded-circle p-3"
                  style={{
                    backgroundColor: "#000",
                  }}
                >
                  <i className="fas fa-phone-alt fa-lg text-white"></i>{" "}
                </div>
              </div>
              <Card.Title>Talk to us</Card.Title>
              <Card.Text style={{ flex: 1 }}>
                We are just a call away. Our representative is eager to hear
                from you. Just take your phone and get going.
              </Card.Text>
              <a
                // href="tel:+1 929-346-1108"
                href="tel:+1 929-346-1108"
                className="btn"
                style={{
                  backgroundColor: "#000",
                  color: "white",
                }}
              >
                (929) 346-1108
              </a>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={4} className="mb-4">
          <Card
            className="h-100 border-0 shadow"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Card.Body className="text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="rounded-circle p-3"
                  style={{
                    backgroundColor: "#000",
                  }}
                >
                  <i className="fas fa-envelope fa-lg text-white"></i>{" "}
                </div>
              </div>
              <Card.Title>Drop us a line</Card.Title>
              <Card.Text style={{ flex: 1 }}>
                You can also reach us via email if you want to discuss anything
                in detail. We will respond to all your queries and give you a
                suitable reply accordingly.
              </Card.Text>
              <a
                href="mailto:support@datacomco.com"
                className="btn"
                style={{
                  backgroundColor: "#000",

                  color: "white",
                }}
              >
                support@datacomco.com
              </a>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={4} className="mb-4">
          <Card className="h-100 border-0 shadow">
            <Card.Body
              className="text-center"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="rounded-circle p-3"
                  style={{
                    backgroundColor: "#000",
                  }}
                >
                  <i className="fas fa-question-circle fa-lg text-white"></i>{" "}
                </div>
              </div>
              <Card.Title>Contact help center</Card.Title>
              <Card.Text style={{ flex: 1 }}>
                Our support staff is there to answer all your queries. We would
                love to hear from you.
              </Card.Text>
              <button
                className="btn"
                style={{
                  backgroundColor: "#000",

                  color: "white",
                }}
              >
                Submit a Ticket
              </button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactComponent;
